module.exports = __webpack_public_path__ + "img/196.f4d77486.jpg";